/**
 * @file Automatically generated by barrelsby.
 */

export * from './blank-layout.component';
